<template>
  <div>
    <!-- <b-img id="modalImage" :src="image" fluid-grow alt="Fluid-grow image"></b-img><br><br><br> -->
    <!-- <img id="modalImage" :src="image"><br><br><br> -->
    <!-- <b-img align="center" :src="image" fluid alt="Responsive image"></b-img><br><br><br> -->
  <b-img id="modalLogo" left :src="img" alt="Left image"></b-img>
    <!-- <h2>{{title}}</h2><br/><hr/><br/> -->
    <div id="modalInfo">
      <h2 id="modalTitle">{{title}}</h2>
      <div v-if="description" v-html="description" class="description"></div><br>
    </div>
    
    <div class="actions-container listActions">
      <div v-for="(action) in actions = divideActions(fastActions)" :key="action.ID">
        <li>{{action}}</li>
      </div>
    </div><br>
    <!-- <h5>Scansiona il QR-Code</h5><br> -->
       <b-form  @submit="sendEmail">


    <b-container class="bv-example-row">
  <b-row>
    <b-col align="left" cols="8">
      <!-- <label for="email">Email</label> -->
      <h5 id="modalEmailTitle">{{$locale.webqrmodal.sendToEmail}}</h5>
      <input 
        id="emailInput"
        type="email"
        placeholder="Inserisci la tua email"
        class="o-pf-input"
        name="email"
        @input="value = $event.target.value"
      /><br>
      
      <b-form-checkbox v-model="switchVal" name="check-newsletter" switch>{{$locale.webqrmodal.subscribeToNewsletter}}</b-form-checkbox><br>
      <a id="privacyPolicy" href="https://www.myappfree.com/en/privacy-policy/">Privacy Policy</a>
      <!-- <button v-on:click="createUser()">Ricevi il link sulla tua Email</button> -->
    </b-col>
    <b-col cols="4">
      <p id="qrTitle">{{$locale.webqrmodal.scanQR}}<br> QR Code</p>
     <qrcode-vue id="qrInput" align="center" :value="url" :size="size" level="H"></qrcode-vue>
    </b-col>
  </b-row><br>

  <b-button id="submitEmail" type="submit" variant="primary">{{$locale.webqrmodal.downloadToEarn}} {{coins}} {{$locale.webqrmodal.money}} </b-button><br>

</b-container>
    </b-form>
  </div>
</template>

<script>
import axios from "axios";
import QrcodeVue from "qrcode.vue";
// import Actions from "./Actions";
// import LastAction from "./LastAction";

export default {
  name: "storeDetail",
  data() {
    return {
      size: 130,
      switchVal: "",
    };
  },
  props: [
    "title",
    "fastActions",
    "coins",
    "img",
    "imgURL",
    "url",
    "publisher",
    "description",
    // "Open"
  ],
  components: {
    QrcodeVue,
    // Actions,
    // LastAction
  },
    /* eslint-disable no-console */
  mounted(){
    (document.getElementById('modalCoins')).innerHTML = this.coins;
 
  },
  methods: {
    uuidv4: function() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(
        c
      ) {
        var r = (Math.random() * 16) | 0,
          v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    },
    divideActions: function(actions) {
      if (actions && actions.length > 0) return actions.split("|");
      else return null;
    },
    sendEmail: function(event) {
      event.preventDefault();
      const email = document.getElementById("emailInput").value;
      console.log(email);
      console.log(this.switchVal);
      console.log(this.url);
      console.log(this.title);
      console.log(this.description),
        console.log(this.publisher),
        console.log(this.img);

      if (this.switchVal) {
        axios.post(
          "https://us-central1-mychips-b31fe.cloudfunctions.net/createUser?publisher=" +
            this.$route.params.apiKey,
          {
            userID: this.uuidv4(),
            email: email,
            tokenMobile: "",
            tokenWeb: ""
          }
        );
      }
      // var desc;
      // // Creo il template per la mail
   
      // if (this.description) desc = this.description;
      // else desc = "Installa e Apri l'applicazione";

      var emailActions = this.divideActions(this.fastActions);
      var actionsTemplate = '';
      emailActions.forEach(el=>{
      actionsTemplate = actionsTemplate + '<li>' + el + '</li>'
    })
    console.log(actionsTemplate);

 const template =
     `<div style="font-family:'Roboto',sans-serif; font-weight: bold; font-size: 25px; overflow: hidden; max-height: 100px;min-height: 100px;height: 100px">
          <img src="`  + this.img + `" width="100px" heigth="100px" align="left" style="border-radius:20px;margin-right: 2%;margin-bottom:2%">
          `+ this.title +` </div>
          <div style="position: relative; margin-top: 10px;font-family:'Roboto',sans-serif;line-height: 2; background-color:whitesmoke;padding:3%;border-radius:5px">
          <ul>`  + actionsTemplate + `</ul></div>
          <a href="` + this.url + `" style="
              font-family:'Roboto',sans-serif;
              color: white;
              font-size: 20px;
              text-align: center;
              text-decoration: none;
              display: inline-block;
              background-color: #008CBA;
              width: 100%;
              padding-top: 10px;
              padding-bottom: 10px;
              margin:10px;
              margin-left:0px;
              border-radius:10px;
          ">Scarica</a>`;
// console.log(desc)
console.log(template)


      axios.post(
        "https://us-central1-mychips-staging.cloudfunctions.net/sendEmail",
        {
          email: email,
          // link: this.val,
          name: this.title,
          // description: desc,
          publisher: this.publisher,
          // img: this.img,
          // actions:actionsTemplate
          template:template
        }
      );

      if(email != '')this.$bvModal.hide("storeDetails");
    }
  }
};
</script>

<style scoped>
#body{
  width: 100%!important;
}
#privacyPolicy {
  position: relative;
  font-size: 0.8rem;
  /* left: 40%; */
  /* top:20%; */
}
#submitEmail {
  background-color: rgb(40, 97, 167);
  border-color: rgb(214, 228, 245);
  width: 100%;
}
#qrTitle{
  font-size: 0.8rem!important;
}

#modalInfo{
  min-height: 18vh;
}

#emailInput{
  margin-bottom:10%;
}

/* .custom-control-input:checked ~ .custom-control-label::before {
    border-color: rgb(40, 97, 167)!important;
    background-color: rgb(40, 97, 167)!important;
}  */

/* #modalImage{
  width: 100%;
  object-fit: cover;
  max-height: 350px!important;
} */
.description{
  overflow: hidden;
  height:10vh;
  font-size: 0.8rem;
}
#modalLogo{
  margin-right: 3%;
  border-radius: 20px;
  width: 25%;
}
.listActions{
  border-radius: 5px;
  padding: 3%;
  background-color:whiteSmoke;
}
#modalEmailTitle{
  margin-bottom: 5%;
}


</style>